import { render, staticRenderFns } from "./teamShopList.vue?vue&type=template&id=8036206a&scoped=true"
import script from "./teamShopList.vue?vue&type=script&lang=js"
export * from "./teamShopList.vue?vue&type=script&lang=js"
import style0 from "./teamShopList.vue?vue&type=style&index=0&id=8036206a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8036206a",
  null
  
)

export default component.exports